<script setup>
import { cloneDeep } from 'lodash';
import {
  watch, ref, nextTick, reactive,
} from 'vue';
import { modelErrorsToHtmlText } from '../../../../libs/cifra/model_errors';

const props = defineProps({
  modelValue: { type: Array, default: () => [] },
  error: { type: [String, Array], default: null },
});

const emits = defineEmits(['update:modelValue']);

const tematicas = reactive([...cloneDeep(props.modelValue)]);
const nombreTematica = ref(null);

function eliminarTematica(index) {
  if (index < 0) { return; }

  const tematica = tematicas[index];
  if (tematica !== null) {
    tematicas.splice(index, 1);
  }
}

function addTematica() {
  tematicas.push('');
  nextTick(() => {
    nombreTematica.value[tematicas.length - 1].focus();
  });
}

watch(tematicas, () => {
  emits('update:modelValue', tematicas);
});
</script>

<template>
  <table class="table m-b-none">
    <thead>
      <tr>
        <th>
          {{ $I18n.t('activerecord.attributes.lomloe/situacion_aprendizaje.tematicas') }}
        </th>
        <th class="col-min">
          <button
            type="button"
            class="btn btn-cifra btn-xs"
            @click="addTematica"
          >
            <i class="fa fa-plus"></i>
          </button>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(_tematica, index) in tematicas" :key="index">
        <td>
          <input ref="nombreTematica" v-model="tematicas[index]" class="form-control">
        </td>
        <td>
          <i
            class="fa fa-trash text-danger clickable"
            @click="eliminarTematica(index)"
          ></i>
        </td>
      </tr>
    </tbody>
  </table>
  <p v-if="props.error" class="text-danger">
    {{ modelErrorsToHtmlText(error) }}
  </p>
</template>

<style scoped>
  table > tbody > tr > td:last-child {
    text-align: center;
  }
  table > tbody > tr > td {
    vertical-align: middle;
  }
  abbr {
    border: 0;
    text-decoration: none;
    color: #fe1d12;
  }
</style>
